import base from './base'

const getCodeLists = (params) => base
  .get('/code_lists/', { params: params }).then(resp => resp.data)

export default {
  getCodeLists: getCodeLists,
}
